/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_PlanInputs */



/**
* | output |
* | --- |
* | "Current Plan" |
*
* @param {Current_PlanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_plan = /** @type {((inputs?: Current_PlanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_PlanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plan actuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktueller Plan")
	if (locale === "it") return /** @type {LocalizedString} */ ("Piano attuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущий план")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plan actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前计划")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の計画")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान योजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Plano atual")
	return /** @type {LocalizedString} */ ("Current Plan")
});